export default __webpack_public_path__ + "static/media/money.d8bd542a.svg";